import { Component, OnInit } from '@angular/core';
import {InicioFaces} from '../interfaces/inicioFaces';
import {GestionthService} from '../services/gestionth.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import{ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';
import {thFaces} from '../interfaces/thFaces';





@Component({
  selector: 'app-gestionth',
  templateUrl: './gestionth.component.html',
  styleUrls: ['./gestionth.component.css']
})
export class GestionthComponent implements OnInit {

  pdfSrc = "";
  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  uploadedFiles : Array<File>;
  creaFrom: FormGroup;
  sedeForm: FormGroup;
  desprendiblesform: FormGroup;
  insert: any = {};
  insertS: any= {};
  ingresaC: any= {};
  certificado: any ={};
  desprendible: any ={};
  tabActual = 1;
  submitted = false;
  inicioTipo: InicioFaces[];
  inicioCedula: InicioFaces[];
  inicioCargo: InicioFaces[];
  inicioContrato: InicioFaces[];
  inicioSede: InicioFaces[];
  buscarC: InicioFaces[];
  buscarS: InicioFaces[];
  buscargo: InicioFaces[];
  buscador: any = {};
  listCertificado: any = {};
  listDesprendible: any = {};
  listS: any = {};
  busCerti: InicioFaces[];
  busDesp: InicioFaces[];
  listC: any = {};
  documento_id: any= null;
  cargoform: FormGroup;
  certificadoForm: FormGroup;


  API_ENDPOINT: string ='http://'+window.location.hostname+':3003';

  constructor(private gestionthService: GestionthService,private httpClient: HttpClient,private formBuilder: FormBuilder,private _route: ActivatedRoute ,private alerts: AlertsService) { }

  ngOnInit() {
  this.listatipdoc();
  this.listacargo();
  this.listacontrato();
  this.listasede();
  this.liscedula();
  this.creaFrom = this.formBuilder.group({
  docid: ['', Validators.required],
  cedula: ['', Validators.required],
  expide: ['', Validators.required],
  user: ['', Validators.required],
  pass: ['', Validators.required],
  contratoid: ['', Validators.required],
  salario: ['', Validators.required],
  nombre: ['', Validators.required],
  cargoid: ['', Validators.required],
  sedeid: ['', Validators.required],
  email: ['', Validators.required],
  fingreso: ['', Validators.required],
  lugarExpide: ['', Validators.required],

  });
  this.sedeForm = this.formBuilder.group({
  sedeid: ['', Validators.required],
  ciudad: ['', Validators.required],
  });

  this.cargoform = this.formBuilder.group({
  ncargo: ['', Validators.required],
  });


  this.certificadoForm = this.formBuilder.group({
  cedulaid: ['', Validators.required],
  namecerti: ['', Validators.required],
  url: ['', Validators.required],

  });

  this.desprendiblesform = this.formBuilder.group({
  docuid: ['', Validators.required],
  namedespre: ['', Validators.required],
  url: ['', Validators.required],

  });

  }



  fileProgress(fileInput: any) {
                  this.fileData = <File>fileInput.target.files[0];
                  this.preview();
              }

  preview() {
  // Show preview
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
        return;
   }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
       this.previewUrl = reader.result;
     }
  }


////////////////CERTIFICADOS EMPIEZA////////////////////////////////////
    limpiaCerti(){
      this.certificado = {};
    }

 onCreaCertificado() {
  this.submitted = true;
      

      const formData = new FormData();
      formData.append('file', this.fileData);
      formData.append('namecerti', this.certificado.namecerti);
      formData.append('cedulaid', this.certificado.cedulaid);


      this.fileUploadProgress = '0%';

      this.gestionthService.insertCertificado(formData, this.certificado).subscribe(events => {
        console.log('events: ', this.certificado);

        if(events.type === HttpEventType.UploadProgress) {
           this.fileUploadProgress = Math.round(events.loaded / events.total * 100) + '%';
        } else if(events.type === HttpEventType.Response) {
           this.fileUploadProgress = '';
           if (events.body.status === 200) {
              this.limpiaCerti();
             this.alerts.setMessage(events.body.msj, 'success');
           } else {
             this.alerts.setMessage(events.body.msj, 'warn');
           }
           
        }

      })
                  
 
  }

  onBuscarCerti() {
  this.gestionthService.buscaCertificado(this.listCertificado).subscribe((data: any) => {
  this.busCerti = data.obj;
  return;
  },
  (error) => {
  alert('Ocurrio un Error listando cargo');
  console.log("imprimir", error);
  });
  }

  onDeleteCertificado(data){
    if(confirm('¿ESTA SEGURO DE ELIMINAR EL CERTIFICADO ASOCIADO?')){
        this.gestionthService.eliminarCertificado(data).subscribe((data: any) => {
        this.alerts.setMessage('CERTIFICADO ELIMINADO CORRECTAMENTE','warn');
        return;
    },
      (error) => {
          alert('ERROR AL ELIMINAR EL CERTIFICADO');
          console.log("imprimir", error);
      });    
    };
  }


     abrirCertificado(pdf: string){
    let url = this.API_ENDPOINT +"/" +pdf;
      console.log('URL AQUITA',pdf);
        window.open(url, "_blank");
    }
//////////////////////////////TERMINA CERTIFICADOS////////////////////////////////////




///////////////////////////////////DESPRENDIBLES EMPIEZA//////////////////////////////
         limpiaDes(){
            this.desprendible = {};
          }

       onCrearDesprendible() {
          console.log('subir */*/*/*/*/*/entrataaaa');
        this.submitted = true;
            

            const formData1 = new FormData();
            formData1.append('file', this.fileData);
            formData1.append('namedespre', this.desprendible.namedespre);
            formData1.append('docuid', this.desprendible.docuid);
            console.log('*/*/***/*/*/DESPRENDIBLE*/*/*/*',this.desprendible);


            this.fileUploadProgress = '0%';

            this.gestionthService.insertDesprendibles(formData1, this.desprendible).subscribe(events => {
              console.log('events: ', events);

              if(events.type === HttpEventType.UploadProgress) {
                 this.fileUploadProgress = Math.round(events.loaded / events.total * 100) + '%';
              } else if(events.type === HttpEventType.Response) {
                 this.fileUploadProgress = '';
                 if (events.body.status === 200) {
                    this.limpiaDes();
                   this.alerts.setMessage(events.body.msj, 'success');
                 } else {
                   this.alerts.setMessage(events.body.msj, 'warn');
                 }
                 
              }

            })
                        
       
        }


    onBuscaDespre() {
      this.gestionthService.buscaDesprendibles(this.listDesprendible).subscribe((data: any) => {
        this.busDesp = data.obj;
        return;
      },
      (error) => {
        alert('Ocurrio un Error listando cargo');
        console.log("imprimir", error);
      });
    }

   abrirDesprendible(pdf: string){
    let url = this.API_ENDPOINT +"/" +pdf;
      console.log('URL DESPRENDIBLE',pdf);
        window.open(url, "_blank");
    }



  onDeleteDesprendible(data){
    if(confirm('¿ESTA SEGURO DE ELIMINAR EL DESPRENDIBLES ASOCIADO?')){
        this.gestionthService.eliminarDesprendible(data).subscribe((data: any) => {
        this.alerts.setMessage('DESPRENDIBLES ELIMINADO CORRECTAMENTE','warn');
        return;
    },
      (error) => {
          alert('ERROR AL ELIMINAR EL DESPRENDIBLES');
          console.log("imprimir", error);
      });    
    };
  }


////////////////////////////////////TERMINA DESPRENDIBLES////////////////////////////////////////

////////////////////////////////////EMPIEZA SEDE ////////////////////////////////////////////////////
  limpiaS(){
      this.insertS = {};
    }

onCreaSede() {
  this.submitted = true;

  if (this.sedeForm.valid) {
      this.gestionthService.crearSede(this.insertS).subscribe((data: any) => {
      this.alerts.setMessage('SEDE CREADA','success');
      this.limpiaS();
      console.log("imprimir", data);
      });
   }else{
  this.alerts.setMessage('ERROR AL CREAR SEDE ','success');
  }


}

onListarsede() {
this.gestionthService.buscarSede(this.listS).subscribe((data: any) => {
this.buscarS = data.obj;
return;
},
(error) => {
alert('OCURRE ERROR LISTANDO SEDE');
console.log("imprimir", error);
});
}

listasede() {    
this.gestionthService.lisede().subscribe((data: any) => {
this.inicioSede = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error');
console.log("imprimir", error);
});
}

onDeleteSede(data){
if(confirm('¿ESTA SEGURO DE ELIMINAR LA SEDE?')){
this.gestionthService.eliminarSede(data).subscribe((data: any) => {
console.log('eliminando SEDE',data);
this.alerts.setMessage('SEDE ELIMINADO CORRECTAMENTE','warn');
return;
},
(error) => {
alert('ERROR AL ELIMINAR SEDE');
console.log("imprimir", error);
});    
};
}


////////////////////////////////////TERMINA SEDE////////////////////////////////////////



////////////////////////////////////EMPIEZA CARGO////////////////////////////////////////
    limpiaC(){
      this.ingresaC = {};
    }


onCreacargo() {
  this.submitted = true;

  if (this.cargoform.valid) {
      this.gestionthService.ingresaCargo(this.ingresaC).subscribe((data: any) => {
      this.alerts.setMessage('CARGO CREADA','success');
      console.log("imprimir", data);
      this.limpiaC();
      });
   }else{
  this.alerts.setMessage('ERROR AL CREAR CARGO ','warn');
  }


}

onBuscarCargo() {
this.gestionthService.buscaCargo(this.listC).subscribe((data: any) => {
this.buscargo = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error listando cargo');
console.log("imprimir", error);
});
}


listacargo() {    
this.gestionthService.liscargo().subscribe((data: any) => {
this.inicioCargo = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error');
console.log("imprimir", error);
});
}

onDeleteCargo(data){
if(confirm('¿ESTA SEGURO DE ELIMINAR EL CARGO?')){
this.gestionthService.eliminarCargo(data).subscribe((data: any) => {
console.log('eliminando CARGO',data);
this.alerts.setMessage('CARGO ELIMINADO CORRECTAMENTE','warn');
return;
},
(error) => {
alert('ERROR AL ELIMINAR EL CARGO');
console.log("imprimir", error);
});    
};
}

////////////////////////////////////TERMINA CARGO////////////////////////////////////////


////////////////////////////////////EMPIEZA COLABORADOR////////////////////////////////////////
       clear(){
      this.insert = {};
    }

    onInsert() {
      this.submitted = true;

        if (this.creaFrom.valid) {
            if(this.documento_id == null){
              this.gestionthService.crearColaborador(this.insert).subscribe((data: any) => {
                this.alerts.setMessage('CREADO CORRECTAMENTE','success');
                this.clear();
                console.log("imprimir", data);
              });
            }else{
                this.gestionthService.updateAll(this.insert).subscribe((data: any) => {
                  this.alerts.setMessage('MODIFICADO CORRECTAMENTE','warn');
                  console.log("imprimir", data);
                  this.clear();
                  });
            }
        }else{
            return;
          }
    }


onDelete(data){

if(confirm('¿ESTA SEGURO DE ELIMINAR EL COLABORADOR?')){
this.gestionthService.eliminarColaborador(data).subscribe((data: any) => {

this.alerts.setMessage('COLABORADOR ELIMINADO CORRECTAMENTE','warn');
return;
},
(error) => {
alert('ERROR AL ELIMINAR');
console.log("imprimir", error);
});    
};
}



onUpdate(documento_id) {
this.gestionthService.buscaColaborador({nombre:documento_id}).subscribe((data: any) => {
if(data.obj.length){
  var obj = data.obj[0];
this.insert.nombre= obj.nombre;
this.insert.docid= obj.tipo_documento;
this.insert.cedula= obj.documento_id;
this.insert.expide= obj.fecha_expedicion.split('T')[0];
this.insert.cargoid= obj.cargo_id;
this.insert.sedeid= obj.sede_id;
this.insert.contratoid= obj.contrato_id;
this.insert.fingreso= obj.fecha_ingreso.split('T')[0];
this.insert.user= obj.user;
this.insert.pass= obj.pass;
this.insert.salario= obj.salario;
this.insert.email= obj.email;
this.insert.lugarExpide= obj.lugarExpide;
this.documento_id = obj.documento_id;
console.log("jumm",obj);
console.log("jumm222",data);

}else{
  alert('ERROR AL OBTENER PERSONA');
}

console.log('lista update',{nombre:documento_id});

return;
},
(error) => {
alert('Ocurrio un Error listando colaboradores');
console.log("imprimir", error);
});
}


onBuscarColaborador() {
this.gestionthService.buscaColaborador(this.buscador).subscribe((data: any) => {
this.buscarC = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error listando colaboradores');
console.log("imprimir", error);
});
}


listatipdoc() {    
this.gestionthService.listipodoc().subscribe((data: any) => {
this.inicioTipo = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error');
console.log("imprimir", error);
});
}

liscedula() {    
this.gestionthService.cargaColaborador().subscribe((data: any) => {
  console.log('oeoeoeoe',data);
this.inicioCedula = data.obj;
return;
},
(error) => {
alert('Ocurrio un Error');
console.log("imprimir", error);
});
}

////////////////////////////////////TERMINA COLABORADOR////////////////////////////////////////






    listacontrato() {    
      this.gestionthService.liscontrato().subscribe((data: any) => {
        this.inicioContrato = data.obj;
        return;
      },
      (error) => {
        alert('Ocurrio un Error');
        console.log("imprimir", error);
      });
    }






}